import type { TablePaginationConfig } from 'antd/es/table/interface'
import i18n from 'i18next'

/** Shared pagination for data tables — responsive, Seekho-style copy. */
export function leapTablePagination(total: number | undefined): TablePaginationConfig {
  return {
    total: total ?? 0,
    pageSize: 10,
    showSizeChanger: true,
    pageSizeOptions: [10, 20, 50, 100],
    showQuickJumper: true,
    showTotal: (t, range) => i18n.t('Common:general.paginationTotal', {
      rangeStart: range[0],
      rangeEnd: range[1],
      total: t,
      defaultValue: `Showing ${range[0]}–${range[1]} of ${t} records`
    }),
    className: 'px-3 pb-3 pt-1 sm:px-4',
  }
}
